import { inject } from '@angular/core';
import { DialogService } from '@core/services';
import { BaseComponent } from '@shared/classes';
import { ProductCheckComponent } from '@shared/components/modals/product-check/product-check.component';
import { ScopeInfoModalComponent } from '@shared/components/modals/scope-info-modal/scope-info-modal.component';
import { StepChallenge } from '@shared/factory';
import { EmitterKeys } from '@shared/models';

export class StepBaseClass extends BaseComponent {
  public readonly shortLocale = this.locale.substring(0, 2);

  private readonly dialog: DialogService = inject(DialogService);

  displayDialog(challenge: StepChallenge, title: string): void {
    this.taggingService.emitTagForKey(
      EmitterKeys.ELIGIBLE_PRODUCTS,
      challenge.getChallengeName()
    );

    this.dialog.open(ProductCheckComponent, {
      data: {
        title,
        item: challenge,
      },
    });
  }

  displayScopeInfoDialog(challenge: StepChallenge): void {
    this.dialog.open(ScopeInfoModalComponent, {
      data: challenge,
    });
  }
}
